import { render, staticRenderFns } from "./ListarSindicatos.vue?vue&type=template&id=1c94b76a&"
import script from "./ListarSindicatos.vue?vue&type=script&lang=js&"
export * from "./ListarSindicatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports